export default __webpack_public_path__ + "static/media/Poste_italiane_logo.663d8c2d.svg";